import React, { useState, useEffect } from 'react';
import API_CONFIG from '../config/api';
import { 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Alert,
  CircularProgress,
  Container,
  Checkbox,
  FormControlLabel,
  Modal,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { 
  LockOutlined, 
  EmailOutlined, 
  Visibility, 
  VisibilityOff,
  Close as CloseIcon,
  Send as SendIcon
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { usePrestadorAuth } from '../contexts/PrestadorAuthContext';
import { useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Link from '@mui/material/Link';
import EditaisPublicosList from '../components/prestador/EditaisPublicosList';

export default function LoginPage() {
  const { login, startGoogleLogin, user } = useAuth();
  const { loginPrestador, prestador } = usePrestadorAuth();
  const navigate = useNavigate();
  const [abaLogin, setAbaLogin] = useState('isg');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [cnpjPrestador, setCnpjPrestador] = useState('');
  const [emailPrestador, setEmailPrestador] = useState('');
  const [senhaPrestador, setSenhaPrestador] = useState('');
  const [modalCadastro, setModalCadastro] = useState(false);
  const [modalProposta, setModalProposta] = useState(false);
  const [formCadastro, setFormCadastro] = useState({
    razaoSocial: '',
    cnpj: '',
    email: '',
    telefone: '',
    responsavel: '',
    observacao: '',
    unidade: ''
  });
  const [unidadesPublicas, setUnidadesPublicas] = useState([]);
  const [formProposta, setFormProposta] = useState({ codigoEdital: '', cnpj: '', email: '', valor: '', descricao: '' });
  const [editalVerificado, setEditalVerificado] = useState(null);
  const [loadingPublic, setLoadingPublic] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [lembrarSenha, setLembrarSenha] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [modalRecuperacao, setModalRecuperacao] = useState(false);
  const [emailRecuperacao, setEmailRecuperacao] = useState('');
  const [loadingRecuperacao, setLoadingRecuperacao] = useState(false);
  const [mensagemRecuperacao, setMensagemRecuperacao] = useState('');
  const [particles, setParticles] = useState([]);
  const [modalPolitica, setModalPolitica] = useState(false);
  const [politicaPrivacidade, setPoliticaPrivacidade] = useState(null);

  // Redirecionar se já estiver logado
  useEffect(() => {
    if (user) navigate('/home');
    else if (prestador) navigate('/prestador/dashboard');
  }, [user, prestador, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const googleError = params.get('google_error');
    if (googleError) {
      setError(googleError);
      window.history.replaceState({}, '', '/login');
    }
  }, []);

  // Carregar dados salvos do "Lembrar senha"
  useEffect(() => {
    const savedEmail = localStorage.getItem('lembrarEmail');
    const savedLembrar = localStorage.getItem('lembrarSenha');
    
    if (savedEmail && savedLembrar === 'true') {
      setEmail(savedEmail);
      setLembrarSenha(true);
    }
  }, []);

  // Criar partículas animadas
  useEffect(() => {
    const createParticles = () => {
      const newParticles = [];
      for (let i = 0; i < 50; i++) {
        newParticles.push({
          id: i,
          x: Math.random() * window.innerWidth,
          y: Math.random() * window.innerHeight,
          size: Math.random() * 3 + 1,
          speedX: (Math.random() - 0.5) * 0.5,
          speedY: (Math.random() - 0.5) * 0.5,
          opacity: Math.random() * 0.5 + 0.1
        });
      }
      setParticles(newParticles);
    };

    createParticles();
    const interval = setInterval(() => {
      setParticles(prev => prev.map(particle => {
        let newX = particle.x + particle.speedX;
        let newY = particle.y + particle.speedY;
        
        // Ajustar posição quando sair da tela
        if (newX > window.innerWidth) newX = 0;
        if (newX < 0) newX = window.innerWidth;
        if (newY > window.innerHeight) newY = 0;
        if (newY < 0) newY = window.innerHeight;
        
        return {
          ...particle,
          x: newX,
          y: newY
        };
      }));
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const handleLoginPrestador = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const ok = await loginPrestador(emailPrestador, cnpjPrestador, senhaPrestador);
    setLoading(false);
    if (ok) {
      navigate('/prestador/dashboard');
    } else {
      setError('Credenciais inválidas ou cadastro pendente de aprovação.');
    }
  };

  const verificarEdital = async () => {
    setLoadingPublic(true);
    setEditalVerificado(null);
    try {
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/public/editais/verificar/${encodeURIComponent(formProposta.codigoEdital.trim())}`);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Edital inválido');
      setEditalVerificado(data.edital);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingPublic(false);
    }
  };

  const enviarSolicitacaoCadastro = async () => {
    setLoadingPublic(true);
    setError('');
    try {
      if (!formCadastro.unidade) {
        throw new Error('Selecione a unidade da solicitação.');
      }
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/public/solicitacao-cadastro-prestador`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          razaoSocial: formCadastro.razaoSocial,
          cnpj: formCadastro.cnpj,
          email: formCadastro.email,
          telefone: formCadastro.telefone,
          responsavel: formCadastro.responsavel,
          observacao: formCadastro.observacao,
          unidade: formCadastro.unidade
        })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Erro ao enviar solicitação');
      setModalCadastro(false);
      setError('');
      alert(data.message || 'Solicitação enviada com sucesso.');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingPublic(false);
    }
  };

  const handleAbrirPolitica = async () => {
    setModalPolitica(true);
    if (politicaPrivacidade) return;
    try {
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/lgpd/politicas-publicas/PRIVACIDADE?unidade=CEAP-SOL`);
      if (res.ok) setPoliticaPrivacidade(await res.json());
    } catch {
      setPoliticaPrivacidade({ titulo: 'Política de Privacidade', conteudo: 'Não foi possível carregar. Acesse após o login em LGPD / Privacidade.' });
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const success = await login(email.trim().toLowerCase(), senha);
    setLoading(false);
    
    if (success) {
      // Salvar ou remover dados do "Lembrar senha"
      if (lembrarSenha) {
        localStorage.setItem('lembrarEmail', email.trim().toLowerCase());
        localStorage.setItem('lembrarSenha', 'true');
      } else {
        localStorage.removeItem('lembrarEmail');
        localStorage.removeItem('lembrarSenha');
      }
      // Redirecionar para o Painel de Entrada após login bem-sucedido
      navigate('/home');
    } else {
      setError('E-mail ou senha inválidos.');
    }
  };

  const handleRecuperacaoSenha = async () => {
    if (!emailRecuperacao.trim()) {
      setMensagemRecuperacao('Por favor, insira um e-mail válido.');
      return;
    }

    setLoadingRecuperacao(true);
    setMensagemRecuperacao('');

    try {
      const response = await fetch(`${API_CONFIG.BACKEND_URL}/api/recuperar-senha`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: emailRecuperacao.trim() })
      });

      const data = await response.json();

      if (response.ok) {
        setMensagemRecuperacao('Solicitação enviada com sucesso! Verifique seu e-mail.');
        setEmailRecuperacao('');
        setTimeout(() => {
          setModalRecuperacao(false);
          setMensagemRecuperacao('');
        }, 3000);
      } else {
        setMensagemRecuperacao(data.error || 'Erro ao enviar solicitação. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro na recuperação de senha:', error);
      setMensagemRecuperacao('Erro de conexão com o servidor. Tente novamente.');
    } finally {
      setLoadingRecuperacao(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(90deg, #e3f2fd 0%, #bbdefb 20%, #90caf9 40%, #64b5f6 60%, #42a5f5 80%, #1976d2 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 80%, rgba(227, 242, 253, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(25, 118, 210, 0.3) 0%, transparent 50%), radial-gradient(circle at 40% 40%, rgba(144, 202, 249, 0.2) 0%, transparent 50%)',
          zIndex: 1
        }
      }}
    >
      {/* Símbolo ISG como plano de fundo */}
      <Box
        sx={{
          position: 'absolute',
          top: '60%',
          left: '75%',
          transform: 'translate(-50%, -50%)',
          width: '60vw',
          height: '60vh',
          opacity: 1,
          zIndex: 1,
          pointerEvents: 'none',
          '@keyframes float': {
            '0%, 100%': {
              transform: 'translate(-50%, -50%) translateY(0px) rotate(0deg)'
            },
            '25%': {
              transform: 'translate(-50%, -50%) translateY(-15px) rotate(1deg)'
            },
            '50%': {
              transform: 'translate(-50%, -50%) translateY(-10px) rotate(0deg)'
            },
            '75%': {
              transform: 'translate(-50%, -50%) translateY(-5px) rotate(-1deg)'
            }
          },
          '@keyframes pulse': {
            '0%, 100%': {
              opacity: 1,
              scale: 1.2
            },
            '50%': {
              opacity: 0.15,
              scale: 1.1
            }
          },
          animation: 'float 5s ease-in-out infinite, pulse 6s ease-in-out infinite'
        }}
      >
        <svg
          viewBox="0 0 1920 1080"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: '100%', height: '100%' }}
        >
          <defs>
            <style>
              {`
                @keyframes lineFlow {
                  0%, 100% { opacity: 0.3; }
                  50% { opacity: 0.9; }
                }
                @keyframes horizontalFlow {
                  0%, 100% { opacity: 0.2; }
                  50% { opacity: 0.6; }
                }
              `}
            </style>
            <linearGradient id="isgGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#e3f2fd" />
              <stop offset="50%" stopColor="#42a5f5" />
              <stop offset="100%" stopColor="#1976d2" />
            </linearGradient>
            <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#1976d2" />
              <stop offset="50%" stopColor="#42a5f5" />
              <stop offset="100%" stopColor="#64b5f6" />
            </linearGradient>
          </defs>
          {/* Símbolo ISG - linhas verticais fluidas e orgânicas */}
          <g stroke="url(#isgGradient)" strokeWidth="3" fill="none" strokeLinecap="round">
            {/* Linhas verticais principais - lado esquerdo */}
            <path
              d="M400 900 Q400 800 400 700 Q400 600 400 500"
              opacity="0.9"
              style={{
                animation: 'lineFlow 4s ease-in-out infinite'
              }}
            />
            <path
              d="M440 900 Q440 760 440 640 Q440 560 440 480"
              opacity="0.50"
              style={{
                animation: 'lineFlow 6s ease-in-out infinite 0.5s'
              }}
            />
            <path
              d="M480 900 Q480 780 480 660 Q480 580 520 520"
              opacity="0.7"
              style={{
                animation: 'lineFlow 6s ease-in-out infinite 1s'
              }}
            />
            <path
              d="M520 900 Q520 740 520 620 Q520 540 520 460"
              opacity="0.6"
              style={{
                animation: 'lineFlow 6s ease-in-out infinite 1.5s'
              }}
            />
            <path
              d="M560 900 Q560 800 560 680 Q560 600 560 500"
              opacity="0.8"
              style={{
                animation: 'lineFlow 6s ease-in-out infinite 2s'
              }}
            />
            
            {/* Linhas verticais secundárias - variações */}
            <path
              d="M360 900 Q360 840 360 760 Q360 680 360 560"
              opacity="0.5"
              style={{
                animation: 'lineFlow 6s ease-in-out infinite 2.5s'
              }}
            />
            <path
              d="M600 900 Q600 820 600 720 Q600 640 600 540"
              opacity="0.6"
              style={{
                animation: 'lineFlow 6s ease-in-out infinite 3s'
              }}
            />
            
            {/* Linhas de conexão horizontais sutis */}
            <path
              d="M360 760 Q460 760 560 760"
              opacity="0.4"
              strokeWidth="1"
              style={{
                animation: 'horizontalFlow 8s ease-in-out infinite'
              }}
            />
            <path
              d="M400 640 Q480 640 560 640"
              opacity="0.5"
              strokeWidth="1"
              style={{
                animation: 'horizontalFlow 8s ease-in-out infinite 1s'
              }}
            />
            <path
              d="M440 560 Q500 560 560 560"
              opacity="0.4"
              strokeWidth="1"
              style={{
                animation: 'horizontalFlow 8s ease-in-out infinite 2s'
              }}
            />
          </g>

          {/* Texto ISG */}
          <text
            x="380"
            y="220"
            fontSize="300"
            fontWeight="bold"
            fill="#0d47a1"
            textAnchor="middle"
            opacity="0.9"
            fontFamily="Arial, sans-serif"
            style={{
              filter: 'drop-shadow(3px 3px 6px rgba(0,0,0,0.4))',
              stroke: '#002171',
              strokeWidth: '2px'
            }}
          >
            ISG
          </text>
          
          {/* Texto "Cuidar e" */}
          <text
            x="400"
            y="320"
            fontSize="80"
            fill="#1b5e20"
            textAnchor="middle"
            opacity="0.8"
            fontFamily="Arial, sans-serif"
            style={{
              filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
              stroke: '#0d2e0d',
              strokeWidth: '1px'
            }}
          >
            Cuidar e
          </text>
          
          {/* Texto "Salvar Vidas" */}
          <text
            x="400"
            y="380"
            fontSize="70"
            fill="#2e7d32"
            textAnchor="middle"
            opacity="0.8"
            fontFamily="Arial, sans-serif"
            style={{
              filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))',
              stroke: '#1b5e20',
              strokeWidth: '1px'
            }}
          >
            Salvar Vidas
          </text>
        </svg>
      </Box>

      {/* Partículas animadas */}
      {particles.map(particle => (
        <Box
          key={particle.id}
          sx={{
            position: 'absolute',
            left: particle.x,
            top: particle.y,
            width: particle.size,
            height: particle.size,
            background: 'rgba(255, 255, 255, 0.6)',
            borderRadius: '50%',
            opacity: particle.opacity,
            zIndex: 2,
            '@keyframes float': {
              '0%, 100%': {
                transform: 'translateY(0px)'
              },
              '50%': {
                transform: 'translateY(-10px)'
              }
            },
            animation: 'float 6s ease-in-out infinite'
          }}
        />
      ))}

      {/* Container principal com glassmorphism */}
      <Container 
        maxWidth={false} 
        sx={{ 
          position: 'relative', 
          zIndex: 10,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          px: { xs: 2, sm: 4, md: 6, lg: 8 }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 450,
            mx: 'auto',
            '@keyframes slideInUp': {
              from: {
                opacity: 0,
                transform: 'translateY(30px)'
              },
              to: {
                opacity: 1,
                transform: 'translateY(0)'
              }
            },
            animation: 'slideInUp 0.8s ease-out'
          }}
        >
          {/* Efeito de brilho */}
          <Box
            sx={{
              position: 'absolute',
              top: -20,
              left: -20,
              right: -20,
              bottom: -20,
              background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
              borderRadius: '30px',
              filter: 'blur(20px)',
              zIndex: -1
            }}
          />

          {/* Formulário principal */}
          <Card
            sx={{
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '25px',
              boxShadow: '0 25px 45px rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                zIndex: -1
              }
            }}
          >
            <CardContent sx={{ p: 4 }}>
              {/* Header */}
              <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                    border: '1px solid rgba(255,255,255,0.3)',
                    '@keyframes pulse': {
                    '0%, 100%': {
                      transform: 'scale(1)'
                    },
                    '50%': {
                      transform: 'scale(1.05)'
                    }
                  },
                  animation: 'pulse 2s ease-in-out infinite'
                  }}
                >
                  <LockOutlined sx={{ fontSize: 40, color: 'rgba(255,255,255,0.9)' }} />
                </Box>
                <Typography 
                  variant="h3" 
                  component="h1" 
                  fontWeight={700} 
                  gutterBottom
                  sx={{ 
                    color: 'rgba(21, 9, 185, 0.82)',
                    textShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    letterSpacing: '1px'
                  }}
                >
                  Login
                </Typography>
                <Typography 
                  variant="body1" 
                  textAlign="center"
                  sx={{ 
                    color: 'rgba(21, 9, 185, 0.82)',
                    fontWeight: 300
                  }}
                >
                  Sistema de Gestão de Contratos ISG
                </Typography>
              </Box>

              {error && (
                <Alert 
                  severity="error" 
                  sx={{ 
                    mb: 3,
                    background: 'rgba(244, 67, 54, 0.1)',
                    border: '1px solid rgba(244, 67, 54, 0.3)',
                    color: 'rgba(21, 9, 185, 0.82)'
                  }}
                >
                  {error}
                </Alert>
              )}

              <Tabs
                value={abaLogin}
                onChange={(_, v) => { setAbaLogin(v); setError(''); }}
                variant="fullWidth"
                sx={{ mb: 2, '& .MuiTab-root': { color: 'rgba(21,9,185,0.7)', fontWeight: 600 }, '& .Mui-selected': { color: 'rgba(21,9,185,0.95) !important' } }}
              >
                <Tab label="Usuário ISG" value="isg" />
                <Tab label="Prestador" value="prestador" />
              </Tabs>

              {abaLogin === 'isg' ? (
              <form onSubmit={handleLogin}>
                <TextField
                  label="E-mail"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                  autoComplete="email"
                  autoFocus
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlined sx={{ color: 'rgba(21, 9, 185, 0.82)' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '15px',
                      border: '1px solid rgba(255,255,255,0.2)',
                      color: 'rgba(255,255,255,0.9)',
                      '&:hover': {
                        border: '1px solid rgba(255,255,255,0.4)',
                      },
                      '&.Mui-focused': {
                        border: '1px solid rgba(255,255,255,0.6)',
                        boxShadow: '0 0 20px rgba(255,255,255,0.2)'
                      }
                    },
                    '& .MuiInputLabel-root': {
                      color: 'rgba(255,255,255,0.7)',
                      '&.Mui-focused': {
                        color: 'rgba(255,255,255,0.9)'
                      }
                    },
                    '& .MuiInputBase-input': {
                      color: 'rgba(255,255,255,0.9)',
                      '&::placeholder': {
                        color: 'rgba(255,255,255,0.5)'
                      }
                    }
                  }}
                />
                
                <TextField
                  label="Senha"
                  type={showPassword ? 'text' : 'password'}
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                  autoComplete="current-password"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlined sx={{ color: 'rgba(21, 9, 185, 0.82)' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          sx={{ color: 'rgba(12, 82, 3, 0.81)' }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '15px',
                      border: '1px solid rgba(255,255,255,0.2)',
                      color: 'rgba(255,255,255,0.9)',
                      '&:hover': {
                        border: '1px solid rgba(255,255,255,0.4)',
                      },
                      '&.Mui-focused': {
                        border: '1px solid rgba(255,255,255,0.6)',
                        boxShadow: '0 0 20px rgba(255,255,255,0.2)'
                      }
                    },
                    '& .MuiInputLabel-root': {
                      color: 'rgba(255,255,255,0.7)',
                      '&.Mui-focused': {
                        color: 'rgba(255,255,255,0.9)'
                      }
                    },
                    '& .MuiInputBase-input': {
                      color: 'rgba(255,255,255,0.9)',
                      '&::placeholder': {
                        color: 'rgba(255,255,255,0.5)'
                      }
                    }
                  }}
                />

                {/* Checkbox e link de recuperação */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, mb: 3 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={lembrarSenha}
                        onChange={(e) => setLembrarSenha(e.target.checked)}
                        sx={{
                          color: 'rgba(255,255,255,0.7)',
                          '&.Mui-checked': {
                            color: 'rgba(255,255,255,0.9)'
                          }
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem' }}>
                        Lembrar senha
                      </Typography>
                    }
                  />
                  <Button
                    onClick={() => setModalRecuperacao(true)}
                    sx={{
                      color: 'rgba(255,255,255,0.8)',
                      textTransform: 'none',
                      fontSize: '0.9rem',
                      '&:hover': {
                        color: 'rgba(255,255,255,1)',
                        background: 'rgba(255,255,255,0.1)'
                      }
                    }}
                  >
                    Esqueceu a senha?
                  </Button>
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  disabled={loading}
                  sx={{
                    py: 1.5,
                    borderRadius: '15px',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    color: 'rgba(12, 82, 3, 0.81)',
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    textTransform: 'none',
                    letterSpacing: '1px',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: 'linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.2) 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
                    },
                    '&:disabled': {
                      background: 'rgba(255,255,255,0.1)',
                      color: 'rgba(255,255,255,0.5)'
                    }
                  }}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: 'rgba(12, 82, 3, 0.81)' }} />
                  ) : (
                    'Entrar'
                  )}
                </Button>

                <Box sx={{ display: 'flex', alignItems: 'center', my: 2, gap: 1 }}>
                  <Box sx={{ flex: 1, height: 1, bgcolor: 'rgba(255,255,255,0.35)' }} />
                  <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>
                    ou
                  </Typography>
                  <Box sx={{ flex: 1, height: 1, bgcolor: 'rgba(255,255,255,0.35)' }} />
                </Box>

                <Button
                  type="button"
                  variant="outlined"
                  fullWidth
                  size="large"
                  disabled={loading}
                  onClick={() => startGoogleLogin()}
                  sx={{
                    py: 1.4,
                    borderRadius: '15px',
                    textTransform: 'none',
                    fontWeight: 700,
                    bgcolor: 'rgba(255,255,255,0.92)',
                    color: '#1f1f1f',
                    borderColor: 'rgba(255,255,255,0.9)',
                    '&:hover': { bgcolor: '#fff', borderColor: '#fff' },
                  }}
                >
                  Entrar com Google
                </Button>
              </form>
              ) : (
              <form onSubmit={handleLoginPrestador}>
                <TextField label="CNPJ" value={cnpjPrestador} onChange={(e) => setCnpjPrestador(e.target.value)} fullWidth margin="normal" placeholder="00.000.000/0000-00" />
                <TextField label="E-mail cadastrado" type="email" value={emailPrestador} onChange={(e) => setEmailPrestador(e.target.value)} fullWidth margin="normal" />
                <TextField label="Senha" type={showPassword ? 'text' : 'password'} value={senhaPrestador} onChange={(e) => setSenhaPrestador(e.target.value)} fullWidth margin="normal" required />
                <Button type="submit" variant="contained" fullWidth size="large" disabled={loading} sx={{ mt: 2, py: 1.5, borderRadius: '15px', textTransform: 'none' }}>
                  {loading ? <CircularProgress size={24} /> : 'Entrar como Prestador'}
                </Button>
              </form>
              )}

              <Box sx={{ mt: 2, textAlign: 'center' }}>
                <Link component="button" type="button" variant="body2" onClick={handleAbrirPolitica} sx={{ display: 'block', mb: 1, color: 'rgba(21,9,185,0.85)' }}>
                  Política de Privacidade (LGPD)
                </Link>
                <Link component="button" type="button" variant="body2" onClick={() => setModalCadastro(true)} sx={{ mr: 2, color: 'rgba(21,9,185,0.85)' }}>
                  Solicitar cadastro de prestador
                </Link>
                <Link component="button" type="button" variant="body2" onClick={() => setModalProposta(true)} sx={{ color: 'rgba(21,9,185,0.85)' }}>
                  Verificar edital
                </Link>
              </Box>

              <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid rgba(21,101,192,0.12)' }}>
                <Typography variant="subtitle2" fontWeight={800} color="primary.dark" gutterBottom>
                  Editais públicos abertos
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
                  Baixe o TR e envie proposta + documentos sem precisar de login (até 3 propostas).
                </Typography>
                <EditaisPublicosList compact />
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Container>

      {/* Modal de Recuperação de Senha */}
      <Modal
        open={modalRecuperacao}
        onClose={() => setModalRecuperacao(false)}
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          p: 2
        }}
      >
        <Card
          sx={{
            maxWidth: 400,
            width: '100%',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '20px',
            boxShadow: '0 25px 45px rgba(0, 0, 0, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.3)'
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" fontWeight={600}>
                Recuperar Senha
              </Typography>
              <IconButton 
                onClick={() => setModalRecuperacao(false)}
                sx={{ color: 'rgba(0,0,0,0.6)' }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Digite seu e-mail para receber instruções de recuperação de senha.
            </Typography>

            <TextField
              label="E-mail"
              type="email"
              value={emailRecuperacao}
              onChange={(e) => setEmailRecuperacao(e.target.value)}
              fullWidth
              margin="normal"
              required
              autoFocus
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                }
              }}
            />

            {mensagemRecuperacao && (
              <Alert 
                severity={mensagemRecuperacao.includes('sucesso') ? 'success' : 'error'} 
                sx={{ mt: 2 }}
              >
                {mensagemRecuperacao}
              </Alert>
            )}

            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                variant="outlined"
                onClick={() => setModalRecuperacao(false)}
                fullWidth
                sx={{ borderRadius: '12px' }}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                onClick={handleRecuperacaoSenha}
                disabled={loadingRecuperacao}
                fullWidth
                startIcon={loadingRecuperacao ? <CircularProgress size={20} /> : <SendIcon />}
                sx={{ 
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)'
                  }
                }}
              >
                {loadingRecuperacao ? 'Enviando...' : 'Enviar'}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Modal>

      <Modal
        open={modalCadastro}
        onClose={() => setModalCadastro(false)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
      >
        <Card sx={{ maxWidth: 480, width: '100%', p: 2 }}>
          <Typography variant="h6" fontWeight={700} gutterBottom>Solicitação de cadastro — Prestador</Typography>
          <FormControl fullWidth margin="dense" size="small">
            <InputLabel>Unidade</InputLabel>
            <Select
              label="Unidade"
              value={formCadastro.unidade}
              onChange={(e) => setFormCadastro((p) => ({ ...p, unidade: e.target.value }))}
              onOpen={async () => {
                if (unidadesPublicas.length) return;
                try {
                  const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/public/unidades`);
                  if (res.ok) setUnidadesPublicas(await res.json());
                } catch {
                  /* ignore */
                }
              }}
            >
              {unidadesPublicas.map((u) => (
                <MenuItem key={u.codigo} value={u.codigo}>{u.nome} ({u.codigo})</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField label="Razão social" fullWidth margin="dense" value={formCadastro.razaoSocial} onChange={(e) => setFormCadastro((p) => ({ ...p, razaoSocial: e.target.value }))} />
          <TextField label="CNPJ" fullWidth margin="dense" value={formCadastro.cnpj} onChange={(e) => setFormCadastro((p) => ({ ...p, cnpj: e.target.value }))} />
          <TextField label="E-mail" fullWidth margin="dense" value={formCadastro.email} onChange={(e) => setFormCadastro((p) => ({ ...p, email: e.target.value }))} />
          <TextField label="Telefone" fullWidth margin="dense" value={formCadastro.telefone} onChange={(e) => setFormCadastro((p) => ({ ...p, telefone: e.target.value }))} />
          <TextField label="Responsável" fullWidth margin="dense" value={formCadastro.responsavel} onChange={(e) => setFormCadastro((p) => ({ ...p, responsavel: e.target.value }))} />
          <TextField label="Observações" fullWidth margin="dense" multiline minRows={2} value={formCadastro.observacao} onChange={(e) => setFormCadastro((p) => ({ ...p, observacao: e.target.value }))} />
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Button fullWidth onClick={() => setModalCadastro(false)}>Cancelar</Button>
            <Button fullWidth variant="contained" disabled={loadingPublic} onClick={enviarSolicitacaoCadastro}>Enviar solicitação</Button>
          </Box>
        </Card>
      </Modal>

      <Modal open={modalProposta} onClose={() => { setModalProposta(false); setEditalVerificado(null); }} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
        <Card sx={{ maxWidth: 440, width: '100%', p: 2 }}>
          <Typography variant="h6" fontWeight={700} gutterBottom>Verificar edital</Typography>
          <TextField label="Código do edital" fullWidth margin="dense" value={formProposta.codigoEdital} onChange={(e) => setFormProposta((p) => ({ ...p, codigoEdital: e.target.value.toUpperCase() }))} />
          <Button variant="outlined" fullWidth sx={{ mt: 1, textTransform: 'none' }} disabled={loadingPublic} onClick={verificarEdital}>Validar edital</Button>
          {editalVerificado && (
            <Alert severity="success" sx={{ mt: 2 }}>
              Edital válido: <strong>{editalVerificado.titulo}</strong>
              {editalVerificado.dataEncerramento && (
                <span>{` — encerra em ${editalVerificado.dataEncerramento}`}</span>
              )}
              <Typography variant="body2" sx={{ mt: 1 }}>Faça login na aba Prestador (após cadastro aprovado) para enviar sua proposta.</Typography>
            </Alert>
          )}
          <Button fullWidth sx={{ mt: 2 }} onClick={() => setModalProposta(false)}>Fechar</Button>
        </Card>
      </Modal>

      <Modal open={modalPolitica} onClose={() => setModalPolitica(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
        <Card sx={{ maxWidth: 640, width: '100%', maxHeight: '85vh', overflow: 'auto', p: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography variant="h6" fontWeight={700}>
              {politicaPrivacidade?.titulo || 'Política de Privacidade'}
            </Typography>
            <IconButton onClick={() => setModalPolitica(false)} size="small"><CloseIcon /></IconButton>
          </Box>
          <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: 14 }}>
            {politicaPrivacidade?.conteudo || 'Carregando...'}
          </Typography>
        </Card>
      </Modal>

    </Box>
  );
} 